import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './SceneList.css';
import DropdownMenu from '../../../../../components/DropdownMenu/DropdownMenu';
import type { DropdownMenuItem } from '../../../../../components/DropdownMenu/DropdownMenu';
import { SceneCardsList } from '../Components/sceneCards';
import type { ScenesListTabType } from '../Components/sceneCards';

export type { ScenesListTabType } from '../Components/sceneCards';

export interface SceneListProps {
  effectiveScenesListTab: ScenesListTabType;
  onScenesListTabChange: (tab: ScenesListTabType) => void;
  sortOptions: DropdownMenuItem[];
  effectiveSortKey: 'sceneCode' | 'sceneSet' | 'sceneLocation' | 'scenePeriod';
  getSortFieldLabel: () => string;
  onSortFieldSelect: (item: DropdownMenuItem) => void;
}

const SceneList: React.FC<SceneListProps> = ({
  effectiveScenesListTab,
  onScenesListTabChange,
  sortOptions,
  effectiveSortKey,
  getSortFieldLabel,
  onSortFieldSelect,
}) => {
  const { t } = useTranslation();
  const [sortMenuVisible, setSortMenuVisible] = useState(false);
  const sortButtonRef = useRef<HTMLButtonElement>(null);
  const [sortButtonPosition, setSortButtonPosition] = useState({ top: 0, left: 0 });
  const [sortButtonWidth, setSortButtonWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (sortMenuVisible && sortButtonRef.current) {
      const rect = sortButtonRef.current.getBoundingClientRect();
      setSortButtonPosition({ top: rect.bottom + 4, left: rect.left });
      setSortButtonWidth(rect.width);
    }
  }, [sortMenuVisible]);

  return (
    <div className="scheduleDetails-tab-content">
      <div className="scheduleDetails-scenesList-tabs">
        <div
          className={`scheduleDetails-scenesList-tab ${effectiveScenesListTab === 'all' ? 'active' : ''}`}
          onClick={() => onScenesListTabChange('all')}
        >
          {t('schedule.allBreakdown')}
        </div>
        <div
          className={`scheduleDetails-scenesList-tab ${effectiveScenesListTab === 'unscheduled' ? 'active' : ''}`}
          onClick={() => onScenesListTabChange('unscheduled')}
        >
          {t('schedule.unscheduled')}
        </div>
        <div
          className={`scheduleDetails-scenesList-tab ${effectiveScenesListTab === 'scheduled' ? 'active' : ''}`}
          onClick={() => onScenesListTabChange('scheduled')}
        >
          {t('schedule.scheduled')}
        </div>

        <div className="scheduleDetails-scenesList-sort">
          <span className="scheduleDetails-scenesList-sort-label">{t('schedule.sortBy')}</span>
          <button
            ref={sortButtonRef}
            className="scheduleDetails-scenesList-sort-field-btn"
            onClick={() => setSortMenuVisible(!sortMenuVisible)}
          >
            {getSortFieldLabel()}
          </button>
          <span className="scheduleDetails-scenesList-sort-label">{t('schedule.sort')}</span>
        </div>

        <DropdownMenu
          items={sortOptions}
          visible={sortMenuVisible}
          onClose={() => setSortMenuVisible(false)}
          onSelect={(item) => {
            onSortFieldSelect(item);
            setSortMenuVisible(false);
          }}
          position={sortButtonPosition}
          width={sortButtonWidth}
          useFixedPosition={true}
          selectedValue={effectiveSortKey}
        />
      </div>
      <div className="scheduleDetails-scenesList-list">
        <SceneCardsList />
      </div>
    </div>
  );
};

export default SceneList;
